import React from 'react';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { KitButton } from 'components/common/cms-kit';
import SummaryTitle from './pageComponents/SummaryTitle';
import SummaryDescriptionText from './pageComponents/SummaryDescriptionText';
import SummaryAdditionalText from './pageComponents/SummaryAdditionalText';

const Container = styled('div')(({ $backgroundImageUrl, $contentAlign, $imageExists }) => ({
  display: 'flex',
  flexFlow: 'row',
  justifyContent: 'center',
  alignItems: 'flex-end',
  backgroundImage: `url('${$backgroundImageUrl}')`,
  '@media screen and (max-width: 899px)': {
    backgroundImage: 'none',
    backgroundSize: 0,
  },
  '@media screen and (min-width: 900px)': {
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    flexDirection:
      $contentAlign === 'right' ? ($imageExists ? 'row-reverse' : 'row') : 'row',
  },
  position: 'relative',
}));

const ContentContainer = styled('div')(({ $imageExists }) => ({
  flexGrow: 1,
  flexShrink: 0,
  flex: 1,
  verticalAlign: 'top',
  '@media screen and (max-width: 899px)': {
    margin: '10px',
    padding: '40px 20px 40px 20px',
    maxWidth: '90%',
  },
  '@media screen and (min-width: 900px)': {
    padding: '60px 10px',
    maxWidth: $imageExists ? '40%' : '90%',
  },
}));

const ImageContainer = styled('div')(({ $imageExists }) => ({
  flexGrow: 0,
  flexShrink: 1,
  minWidth: '50%',
  margin: 0,
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
  '@media screen and (min-width: 900px)': {
    display: !$imageExists ? 'none' : 'block',
    maxWidth: $imageExists ? '50%' : 0,
    maxHeight: $imageExists ? '95%' : 0,
  },
}));

const SummaryWithBackgroundImage = ({ module }) => {
  const { fields } = module;

  const router = useRouter();

  const _callAction = (event) => {
    event.preventDefault();
    router.push(fields.actionButtonUrl.href);
  };

  const imageExists =
    fields.summaryImage &&
    fields.summaryImage.url &&
    fields.summaryImage.url.length > 0;

  return (
    <React.Fragment>
      <Container
        $backgroundImageUrl={fields.backgroundImage.url}
        $contentAlign={fields.contentAlign}
        $imageExists={imageExists}
      >
        <ContentContainer $imageExists={imageExists}>
          <SummaryTitle content={fields.title} textColor={fields.titleColor} />

          <SummaryDescriptionText content={fields.description} textColor={fields.textColor} />

          <SummaryAdditionalText
            content={fields.additionalText}
            textColor={fields.additionalTextColor}
            textSize={fields.additionalTextSize}
          />

          <div style={{ marginTop: 30 }}>
            {fields.actionButtonUrl &&
              fields.actionButtonUrl.text &&
              fields.actionButtonUrl.text.length > 0 && (
                <Link
                  href={fields.actionButtonUrl.href}
                  target={fields.actionButtonUrl.target}
                  rel={`noopener noreferrer${
                    fields.addNoFollowtoActionUrl === 'true' ? ' nofollow' : ''
                  }`}
                >
                  <KitButton color={fields.actionButtonColor} round>
                    {fields.actionButtonUrl.text}
                  </KitButton>
                </Link>
              )}
          </div>
        </ContentContainer>
        <ImageContainer $imageExists={imageExists}>
          {fields.summaryImage && (
            <img src={fields.summaryImage?.url} alt={fields.title} />
          )}
        </ImageContainer>
      </Container>
    </React.Fragment>
  );
};

export default SummaryWithBackgroundImage;
